import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const loginAttemptsApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  reducerPath: 'loginAttemptsApi',
  tagTypes: ['LoginAttempt'],
  endpoints: () => ({})
})

export default loginAttemptsApi
